import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

export function Table({ head, colgroup, body, className, responsive, bordered, ...props }) {
  return (
    <div className={responsive ? styles.table_responsive : undefined}>
      <table
        className={classNames(styles.table, className, bordered && styles.table__bordered)}
        {...props}
      >
        {colgroup}
        {head && <thead className={classNames(styles.table_head)}>{head}</thead>}
        {body && <tbody className={classNames(styles.table_body)}>{body}</tbody>}
      </table>
    </div>
  );
}

Table.propTypes = {
  bordered: PropTypes.bool,
  colgroup: PropTypes.node,
  head: PropTypes.node,
  body: PropTypes.node,
  className: PropTypes.string,
  responsive: PropTypes.bool,
};
